// ---------------------------------------------------------
// | Imports
// ---------------------------------------------------------

// Common of angular

import { ModuleWithProviders, NgModule } from '@angular/core';

// Services

import { API } from './services/api';

// Directives

import { DirectivesModule } from './share/directives/yzt-directives.modules';

// Tokens (eg. global services' config)

import { NzRootConfig } from 'ng-zorro-antd';

// Modules

import { GoodSelectModule } from './good-select/good-select.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { EchartsModule } from './echarts/echarts.component';
import { UIGridModule } from './ui-grid/ui-grid.component';
import { ShipperSelectModule } from './shipper-select/shipper-select.component';
import { GridIconModule } from './ui-grid/grid-icon.component';
import { YztUploadModule } from './upload/yzt-upload.module';
import { YZTViewerDirectiveModule } from './yzt-viewer/yzt-viewer.directive';
import { RepairGoodSelectModule } from './repair-goods-select/repair-goods-select.component';
import { CneeSelectModule } from './cnee-select/cnee-select.component';
import { MasterSelectModule } from './master-select/master-select.component';
import { AreaSelectModule } from './area-select/area-select.component';
import { AbnormalSelectModule } from './abnormal-select/abnormal-select.component';
// ---------------------------------------------------------
// | Exports
// ---------------------------------------------------------
// interface
export {YztUploadFile} from './upload/interface';

export { API } from './services/api';

export { GoodSelectModule, GoodSelectComponent } from './good-select/good-select.component';
export { NgZorroAntdModule } from 'ng-zorro-antd';
export { EchartsModule, EchartsDirective } from './echarts/echarts.component';
export { UIGridModule, UIGridComponent } from './ui-grid/ui-grid.component';
export { ShipperSelectModule, ShipperSelectComponent } from './shipper-select/shipper-select.component';
export { GridIconModule, GridIconComponent } from './ui-grid/grid-icon.component';
export { YztUploadModule } from './upload/yzt-upload.module';
export { YztUploadComponent } from './upload/yzt-upload.component';
export { YZTViewerDirectiveModule, YZTViewerDirective } from './yzt-viewer/yzt-viewer.directive';
export { RepairGoodSelectModule, RepairGoodSelectComponent } from './repair-goods-select/repair-goods-select.component';
export { CneeSelectModule, CneeSelectComponent } from './cnee-select/cnee-select.component';
export { MasterSelectModule, MasterSelectComponent } from './master-select/master-select.component';
export { AreaSelectModule, AreaSelectComponent } from './area-select/area-select.component';
export { AbnormalSelectModule, AbnormalSelectComponent } from './abnormal-select/abnormal-select.component';

// Components

// Services

// Tokens (eg. global services' config)
export { NzRootConfig } from 'ng-zorro-antd';
export class YztCustomModule {
/**
 * @param {?=} options
 * @return {?}
 */
static forRoot(options?: NzRootConfig): ModuleWithProviders {
    return {
      ngModule: YztCustomModule,
      providers: [
        
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [
    NgZorroAntdModule,
    GoodSelectModule,
    EchartsModule,
    UIGridModule,
    ShipperSelectModule,
    RepairGoodSelectModule,
    GridIconModule,
    DirectivesModule,
    YztUploadModule,
    YZTViewerDirectiveModule,
    CneeSelectModule,
    MasterSelectModule,
    AbnormalSelectModule,
    AreaSelectModule
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function YztCustomModule_tsickle_Closure_declarations() {
/** @type {?} */
YztCustomModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztCustomModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
